import { get } from 'lodash';

import { BEGIN_AJAX_CALL, END_AJAX_CALL } from '../common/actionType';
import {
  ATTEMPT_LOGIN_SUCCESS,
  CLEAR_GUEST_DATA,
  DISPATCH_AUTH_TOKEN,
  DISPATCH_GUEST_DATA,
  DISPATCH_SIGNIN_DATA,
  DISPATCH_RECOVER_USER_DETAILS,
} from './actionType';
import {
  getUserProfileDataApi,
  logoutAllDevicesApi,
  logoutApi,
  sendOtpApi,
  updateProfileApi,
  recoverAccountApi,
  verifyOtpApi,
} from '../../api/api';

import { beginAjaxCallAction, endAjaxCallAction } from '../common';

import {
  CLEAR_GUEST_CASH_CARDS,
  CLEAR_VERIFIED_LOCALITY,
  DISPATCH_REQUESTED_ASSISTANCES_TIMESTAMP,
} from '../actionType';
import {
  EMPTY_REWARD_GUEST_DETAILS,
  FETCH_GUEST_LAST_ORDER,
  UPDATE_GUEST_COUPON_FILTER,
} from '../partner/actionType';
import { DISPATCH_RECOVER_ACCOUNT_CONTEXT } from '../authentication/actionType';
import { storageTypes } from '../../constants/globals';
import { isNativeWebView } from '../../utils/helpers';
import { getItem } from '../../utils/storage';

export const dispatchGuestDataAction = (guestData) => async (dispatch) => {
  dispatch({
    type: DISPATCH_GUEST_DATA,
    guestData,
  });
};

export const clearGuestDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_DATA,
  });
};

export const dispatchSignInDataAction = (signIn) => async (dispatch) => {
  dispatch({
    type: DISPATCH_SIGNIN_DATA,
    signIn,
  });
};

export const updateProfileAction = (updateProfileReqBody, guestId) => async (dispatch) => {
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    const updateProfileData = await updateProfileApi({
      updateProfileReqBody,
      guestId,
    })
      .then((response) => {
        localStorage.setItem('GuestLoginData', JSON.stringify(get(response, 'data', {})));
        dispatch({
          type: ATTEMPT_LOGIN_SUCCESS,
          loginData: get(response, 'data', {}),
        });
        dispatch(dispatchGuestDataAction(get(response, 'data', {})));
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response.data', {});
      });
    return updateProfileData;
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const getUserProfileDataAction = (guestId) => async (dispatch) => {
  let userProfileData = {};
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    userProfileData = await getUserProfileDataApi({ guestId });
    localStorage.setItem('GuestLoginData', JSON.stringify(get(userProfileData, 'data', {})));
    dispatch({
      type: ATTEMPT_LOGIN_SUCCESS,
      loginData: get(userProfileData, 'data', {}),
    });
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const dispatchGuestLoginDataAction = (guestLoginData) => async (dispatch) => {
  localStorage.setItem('GuestLoginData', JSON.stringify(get(guestLoginData, 'guest', {})));
  localStorage.setItem('AuthData', JSON.stringify(get(guestLoginData, 'auth', {})));
  dispatch({
    type: ATTEMPT_LOGIN_SUCCESS,
    loginData: get(guestLoginData, 'guest', {}),
  });
  dispatch({
    type: DISPATCH_AUTH_TOKEN,
    authData: get(guestLoginData, 'auth', {}),
  });
};

export const dispatchLogoutAction = () => (dispatch) => {
  try {
    if (isNativeWebView) {
      const data = {
        eventType: { type: 'logout' },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    localStorage.setItem('GuestLoginData', JSON.stringify({}));
    localStorage.setItem('AuthData', JSON.stringify({}));
    dispatch({
      type: ATTEMPT_LOGIN_SUCCESS,
      loginData: {},
    });
    dispatch({
      type: FETCH_GUEST_LAST_ORDER,
      guestLastOrder: {},
    });
    dispatch({
      type: DISPATCH_AUTH_TOKEN,
      authData: {},
    });
    dispatch(clearGuestDataAction());
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const dispatchAuthTokenAction = (authData) => (dispatch) => {
  localStorage.setItem('AuthData', JSON.stringify(authData || {}));
  dispatch({
    type: DISPATCH_AUTH_TOKEN,
    authData: authData || {},
  });
};

export const logoutAction =
  ({ allDevices = false } = {}) =>
  async (dispatch) => {
    let response = {};

    try {
      const authData = getItem(storageTypes.localStorage, 'AuthData', {});
      const refreshToken = get(authData, 'refreshToken', '');
      response = allDevices
        ? await logoutAllDevicesApi()
        : await logoutApi({ refreshToken });
    } catch (error) {
      // A server-side session may already be invalid. Local logout must still finish.
      response = get(error, 'response', {});
    } finally {
      dispatch(dispatchLogoutAction());
    }

    return response;
  };

export const sendOtpAction = (requestBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const sendOtpResponse = await sendOtpApi(requestBody)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return sendOtpResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const verifyOtpAction =
  ({ mobileNumber, countryCode, otp, recover }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const verifyOtpResponse = await verifyOtpApi({ mobileNumber, countryCode, otp, recover })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return verifyOtpResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const recoverAccountAction =
  ({ recoverAccountReqBody }) =>
  async () => {
    const signInByTrueCallerResponse = await recoverAccountApi({ recoverAccountReqBody })
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return signInByTrueCallerResponse;
  };

export const dispatchRecoverUserDetailsAction =
  ({ recoverUserDetails }) =>
  async (dispatch) => {
    dispatch({
      type: DISPATCH_RECOVER_USER_DETAILS,
      recoverUserDetails,
    });
  };

export const dispatchRecoverAccountContext = (recoverAccount) => async (dispatch) => {
  dispatch({
    type: DISPATCH_RECOVER_ACCOUNT_CONTEXT,
    recoverAccount,
  });
};
